import { render, staticRenderFns } from "./AmDataTable.vue?vue&type=template&id=f46bb526&scoped=true&"
import script from "./AmDataTable.vue?vue&type=script&lang=js&"
export * from "./AmDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46bb526",
  null
  
)

export default component.exports